import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetOrderByIdQuery } from '../../Common/types/Queries/IGetOrderByIdQuery';

export const getOrderById = createAsyncThunk('Order/getOrderById', async (query: IGetOrderByIdQuery) => {
  return await OrdersHttpGetService({
    url: `${_apiPathManagerConfig?.Orders.Order.GetOrderById}`,
    params: query,
  });
});
